namespace SorAraBul.Administration {
    export interface PurchasePackagesRow {
        Id?: number;
        PackageCode?: string;
        Name?: string;
        Subtitle?: string;
        ReportCount?: number;
        UnitPrice?: number;
        CurrencyId?: number;
        CurrencyLookupName?: string;
        CurrencyCode?: string;
        CurrencySymbol?: string;
        BadgeText?: string;
        ButtonText?: string;
        IsPopular?: boolean;
        SortOrder?: number;
        IsActive?: number;
        Features?: PurchasePackageFeaturesRow[];
        InsertDate?: string;
        InsertUserId?: number;
        UpdateDate?: string;
        UpdateUserId?: number;
    }

    export namespace PurchasePackagesRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Administration.PurchasePackages';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'Administration:SuperAdmin';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            PackageCode = "PackageCode",
            Name = "Name",
            Subtitle = "Subtitle",
            ReportCount = "ReportCount",
            UnitPrice = "UnitPrice",
            CurrencyId = "CurrencyId",
            CurrencyLookupName = "CurrencyLookupName",
            CurrencyCode = "CurrencyCode",
            CurrencySymbol = "CurrencySymbol",
            BadgeText = "BadgeText",
            ButtonText = "ButtonText",
            IsPopular = "IsPopular",
            SortOrder = "SortOrder",
            IsActive = "IsActive",
            Features = "Features",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            UpdateDate = "UpdateDate",
            UpdateUserId = "UpdateUserId"
        }
    }
}
